import { render, staticRenderFns } from "./ArtistSubmissions.vue?vue&type=template&id=a271295a&scoped=true"
import script from "./ArtistSubmissions.vue?vue&type=script&lang=js"
export * from "./ArtistSubmissions.vue?vue&type=script&lang=js"
import style0 from "./ArtistSubmissions.vue?vue&type=style&index=0&id=a271295a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a271295a",
  null
  
)

export default component.exports